import IMask from 'imask';

import Base from '../base';
import Slider from './product-filters-slider';

const THOUSAND_SEPARATOR_DEFAULT = '.';
const DECIMAL_SEPARATOR_DEFAULT = ',';
const PRECISION_DEFAULT = 2;

const optionsDefault = {
	thousandSeparator: THOUSAND_SEPARATOR_DEFAULT,
	decimalSeparator: DECIMAL_SEPARATOR_DEFAULT,
	precision: PRECISION_DEFAULT,
};

class ProductFiltersLinkedFields extends Base {
	// copy defaults to prevent overriding in other instances
	constructor(el, options = { ...optionsDefault }) {
		super(el, options);

		this.isCreated = false;

		this.start();
	}

	start() {
		if (!this.refs.from || !this.refs.to) {
			console.warn(`no "from" (${this.refs.from}), or "to" field (${this.refs.to})`);

			return;
		}

		this.init();
	}

	init() {
		this.onMutation = this.onMutation.bind(this);

		this.createObserver();
		this.createFormattedInputs();
		this.createSlider();
	}

	createObserver() {
		const config = { attributes: true };

		this.observer = new MutationObserver(this.onMutation);
		this.observer.observe(this.el, config);
	}

	createFormattedInputs() {
		const {
			precision: scale,
			thousandSeparator: thousandsSeparator,
			decimalSeparator: radix,
			max,
		} = this.options;

		this.fromFormatted = new IMask(this.refs.from, {
			mask: Number,
			scale,
			thousandsSeparator,
			radix,
			max,
			padFractionalZeros: true,
			signed: false,
			min: 0.01,
		});

		this.toFormatted = new IMask(this.refs.to, {
			mask: Number,
			scale,
			thousandsSeparator,
			radix,
			max,
			padFractionalZeros: true,
			signed: false,
			min: 0.01,
		});

		this.isCreated = true;
	}

	createSlider() {
		if (!this.options.hasSlider) {
			return;
		}

		const { fromFormatted: inputFrom, toFormatted: inputTo } = this;

		this.slider = new Slider(this.el, {
			inputFrom,
			inputTo,
		});
	}

	toggleInputs(enabled) {
		const { from, to } = this.refs;

		from.disabled = !enabled;
		to.disabled = !enabled;
	}

	destroyInputs() {
		if (!this.isCreated) {
			return;
		}

		const fromValue = this.fromFormatted.unmaskedValue;
		const toValue = this.toFormatted.unmaskedValue;

		this.fromFormatted.destroy();
		this.toFormatted.destroy();

		this.refs.from.value = fromValue;
		this.refs.to.value = toValue;

		this.isCreated = false;
	}

	onMutation() {
		const isVisible = this.el.hasAttribute('data-is-visible');

		this.toggleInputs(isVisible);
	}
}

export default ProductFiltersLinkedFields;
